package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Paint
import androidx.compose.ui.graphics.PaintingStyle
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.drawIntoCanvas
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.models.JobStatus
import com.hyperether.goodjob.models.Repeat
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.repository.Mapper
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_job
import com.hyperether.goodjob.resources.add
import com.hyperether.goodjob.resources.add_more
import com.hyperether.goodjob.resources.add_new_job
import com.hyperether.goodjob.resources.add_note
import com.hyperether.goodjob.resources.add_notes
import com.hyperether.goodjob.resources.add_steps
import com.hyperether.goodjob.resources.are_you_sure
import com.hyperether.goodjob.resources.baseline_file_present_24
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.contact_deteils
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.contact_site
import com.hyperether.goodjob.resources.date_error
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.due_date
import com.hyperether.goodjob.resources.end_at
import com.hyperether.goodjob.resources.enter_job_title
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.every_2_weeks
import com.hyperether.goodjob.resources.every_day
import com.hyperether.goodjob.resources.every_month
import com.hyperether.goodjob.resources.every_week
import com.hyperether.goodjob.resources.files
import com.hyperether.goodjob.resources.job_added
import com.hyperether.goodjob.resources.job_start_time_error
import com.hyperether.goodjob.resources.job_status
import com.hyperether.goodjob.resources.job_title_mandatory
import com.hyperether.goodjob.resources.job_updated
import com.hyperether.goodjob.resources.max_size
import com.hyperether.goodjob.resources.never
import com.hyperether.goodjob.resources.notes
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.only_support
import com.hyperether.goodjob.resources.provide_information
import com.hyperether.goodjob.resources.repeat
import com.hyperether.goodjob.resources.repeat_interval
import com.hyperether.goodjob.resources.select_job_status
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.start_at
import com.hyperether.goodjob.resources.start_date
import com.hyperether.goodjob.resources.start_end_time
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.resources.try_another_document
import com.hyperether.goodjob.resources.update
import com.hyperether.goodjob.resources.update_job
import com.hyperether.goodjob.resources.upload_cloud
import com.hyperether.goodjob.resources.upload_documents
import com.hyperether.goodjob.scenes.addNew.components.AddNewJobDropdownInput
import com.hyperether.goodjob.scenes.addNew.components.AssignEmployeeDropdown
import com.hyperether.goodjob.scenes.addNew.components.ReadOnlyTimePickerField
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.MobileHeaderBackAndAction
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.jobs.AppInputFieldWithUpdate
import com.hyperether.goodjob.scenes.register.AppInputField
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.JobStatusMap
import com.hyperether.goodjob.util.ScheduleUtil
import com.hyperether.goodjob.util.UploadManager
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import io.wojciechosak.calendar.config.SelectionMode
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import org.jetbrains.compose.resources.painterResource
import org.lighthousegames.logging.logging

@Composable
fun AddNewJobScreen(
    jobId: String?,
    isMobile: Boolean,
    viewModel: AddJobViewModel,
    navHostController: NavHostController,
    onUploadDocumentClick: (String, DocumentType) -> Unit
) {
    val log = logging("AddNewJobScreen")
    val users by viewModel.users.collectAsState(emptyList())
    val teams by viewModel.teams.collectAsState(emptyList())
    val job by viewModel.selectedJob.collectAsState()
    val contacts by viewModel.contacts.collectAsState(initial = emptyList())
    val fileIds by viewModel.fileIds.collectAsState(initial = viewModel.fileIds.value)

    val startDateString = stringResource(Res.string.start_date)
    val dueDateString = stringResource(Res.string.due_date)
    val startAtString = stringResource(Res.string.start_at)
    val endAtString = stringResource(Res.string.end_at)
    viewModel.startDateInputPlaceholder.value = startDateString
    viewModel.dueDatePlaceholder.value = dueDateString
    viewModel.startInputPlaceholder.value = startAtString
    viewModel.endInputPlaceholder.value = endAtString

    viewModel.jobStatusMap = JobStatusMap()
    viewModel.repeatIntervalMap = ScheduleUtil.getRepeatIntervalDaily()
    viewModel.repeatMap = mapOf(
        stringResource(Res.string.never) to Repeat.never.name,
        stringResource(Res.string.every_day) to Repeat.every_day.name,
        stringResource(Res.string.every_week) to Repeat.every_week.name,
        stringResource(Res.string.every_2_weeks) to Repeat.every_2_weeks.name,
        stringResource(Res.string.every_month) to Repeat.every_month.name
//    stringResource(Res.string.custom) to Repeat.custom.name
    )

    DisposableEffect(Unit) {
        onDispose {
            viewModel.clearJobValues()
        }
    }

    LaunchedEffect(Unit) {
        viewModel.repeatValue.value =
            viewModel.repeatMap.entries.find { it.value == Repeat.never.name }?.key
                ?: viewModel.repeatValue.value

        viewModel.jobStatusPlaceholderValue.value =
            viewModel.jobStatusMap.entries.find { it.value == JobStatus.draft.name }?.key
                ?: JobStatus.draft.name

        // TODO: check if loadRemoteData needed
        viewModel.loadData()
    }

    LaunchedEffect(jobId) {
        viewModel.onJobIdChanged(jobId)
        when (jobId) {
            null -> viewModel.clearJobValues()
            DEFAULT_JOB_ID -> viewModel.clearJobValues()
            "" -> viewModel.clearJobValues()
            else -> viewModel.getJobById(jobId)
        }
    }

    LaunchedEffect(job) {
        if (jobId != DEFAULT_JOB_ID && jobId != "") {
            job.let { job1 ->
                if (job1 != null) {
                    viewModel.contactName.value =
                        contacts.firstOrNull { it.id == job1.contactParentId }?.name
                            ?: viewModel.contactName.value
                    log.d("JOB") { "viewModel.contactName: ${viewModel.contactName.value}" }
                    viewModel.contactSite.value =
                        job1.contactSiteName ?: viewModel.contactSite.value
                    viewModel.jobTitleInput.value = job1.jobTitle ?: viewModel.jobTitleInput.value
                    viewModel.jobStatusValue.value =
                        viewModel.jobStatusMap.entries.find { it.value == job1.status }?.key
                            ?: viewModel.jobStatusValue.value
                    viewModel.startDateInputValue.value =
                        job1.startDate.takeIf { it?.isNotEmpty() == true } ?: startDateString
                    viewModel.startInputValue.value =
                        job1.start_at.takeIf { it?.isNotEmpty() == true } ?: startAtString
                    viewModel.endInputValue.value =
                        job1.end_at.takeIf { it?.isNotEmpty() == true } ?: endAtString
                    viewModel.dueDateValue.value =
                        job1.dueDate.takeIf { it?.isNotEmpty() == true } ?: dueDateString
                    viewModel.repeatValue.value =
                        viewModel.repeatMap.entries.find { it.value == job1.repeat }?.key
                            ?: viewModel.repeatValue.value
                    viewModel.contactParentId.value =
                        job1.contactParentId ?: viewModel.contactParentId.value
                    viewModel.contactSiteId.value =
                        job1.contactSiteId ?: viewModel.contactSiteId.value
                    viewModel.selectedSiteName.value =
                        job1.contactSiteName ?: viewModel.selectedSiteName.value
                    job1.assignees?.let { assignees ->
                        viewModel.preselectedUsers.clear()
                        assignees.employees?.let { employeeObjects ->
                            val employeesIds = employeeObjects.mapNotNull { it?._id }.distinct()
                            val userList = users.filter { user -> employeesIds.contains(user._id) }
                            viewModel.preselectedUsers.addAll(userList)
                        }
                        viewModel.jobSelectedEmployeeList.value = viewModel.preselectedUsers

                        viewModel.preselectedTeamsJob.clear()
                        assignees.teams?.let { teamObjects ->
                            val ids = teamObjects.mapNotNull { it?._id }.distinct()
                            val teamList = teams.filter { team -> ids.contains(team._id) }
                            viewModel.preselectedTeamsJob.addAll(teamList)
                        }
                        viewModel.jobSelectedTeamList.value = viewModel.preselectedTeamsJob
                    }
                    viewModel.durationText.value =
                        job1.jobDuration?.toString() ?: viewModel.jobDurationValue.value.toString()
                    viewModel.notesListValue.addAll(
                        job1.noteObjects?.toMutableList() ?: emptyList()
                    )

                    viewModel.steps.clear()
                    viewModel.steps.addAll(
                        if (job1.steps.isNullOrEmpty()) {
                            viewModel.steps
                        } else {
                            Mapper().toStepDataList(job1.steps.orEmpty().filterNotNull())
                        }
                    )

                    viewModel.isRepeatActive.value = job1.repeat?.isNotEmpty() == true &&
                            job1.repeat != Repeat.never.name
                    job1.repeatInterval?.let {
                        when (job1.repeat) {
                            Repeat.every_day.name -> {
                                if (it.isNotEmpty())
                                    it[0]?.let { interval ->
                                        viewModel.repeatIntervalMap.entries.find { rInt -> rInt.value == interval }?.key?.let { key ->
                                            viewModel.repeatDailyValue.value = key
                                        }
                                    }
                            }

                            else -> {

                            }
                        }
                    }

                    UploadManager.downloadJobFiles(job1, viewModel.repository, showLoader = null)
                }
            }
        } else {
            viewModel.clearJobValues()
            viewModel.startDateInputValue.value = startDateString
            viewModel.dueDateValue.value = dueDateString
            viewModel.startInputValue.value = startAtString
            viewModel.endInputValue.value = endAtString
            viewModel.jobStatusValue.value =
                viewModel.jobStatusMap.entries.find { it.value == JobStatus.draft.name }?.key
                    ?: JobStatus.draft.name
        }
    }

    if (isMobile) {
        Column(
            modifier = Modifier
                .verticalScroll(rememberScrollState())
                .disableMouseDragScrollOnWeb()
        ) {
            MobileHeaderBackAndAction(
                title = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(Res.string.add_new_job) else stringResource(
                    Res.string.update_job
                ),
                back = {
                    viewModel.clearJobValues()
                    navHostController.navigateUp()
                }
            )

            Spacer(modifier = Modifier.height(Dp(15f)))
            Column(modifier = Modifier.padding(start = Dp(16f), end = Dp(16f))) {
                Column(
                    verticalArrangement = Arrangement.spacedBy(10.toScaleDp())
                ) {
                    Text(
                        text = stringResource(Res.string.contact_deteils),
                        color = Color.Black,
                        fontSize = 24.toScaleSp(),
                        fontWeight = FontWeight.Bold,
                    )

                    DisableSelection {
                        AboutContactDropdown(
                            viewModel.contactName,
                            stringResource(Res.string.contact_name),
                            placeholder = stringResource(Res.string.contact_name),
                            dropdownItems = contacts,
                            onContactSelected = { contactId ->
                                viewModel.contactParentId.value = contactId
                                viewModel.contactSite.value = ""
                                viewModel.getContactSites(contactId)
                            }
                        )
                    }

                    if (viewModel.contactSites.size > 1) {
                        DisableSelection {
                            AboutSiteDropdown(
                                viewModel.contactSite,
                                stringResource(Res.string.contact_site),
                                placeholder = stringResource(Res.string.site),
                                dropdownItems = viewModel.contactSites,
                                onSiteSelected = { site ->
                                    viewModel.selectedSiteName.value = site.siteName ?: ""
                                    viewModel.contactSiteId.value = site.id ?: ""
                                }
                            )
                        }
                    } else {
                        if (viewModel.contactSites.isNotEmpty()) {
                            viewModel.contactSites[0].siteName?.let {
                                viewModel.selectedSiteName.value = it
                            }
                            viewModel.contactSites[0].id?.let { viewModel.contactSiteId.value = it }
                        }
                    }

                    Text(
                        text = stringResource(Res.string.about_job),
                        color = Color.Black,
                        fontSize = 24.toScaleSp(),
                        fontWeight = FontWeight.Bold,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )

                    AppInputField(
                        viewModel.jobTitleInput,
                        stringResource(Res.string.job_title_mandatory),
                        placeholder = stringResource(Res.string.enter_job_title),
                        paddingTop = 0.toScaleDp()
                    )

                    DisableSelection {
                        AddNewJobDropdownInput(
                            viewModel.jobStatusValue,
                            stringResource(Res.string.job_status),
                            placeholder = stringResource(Res.string.select_job_status),
                            dropdownItems = viewModel.jobStatusMap,
                        )
                    }

                    val activeUsers =
                        users.filter { it.confirmStatus == UserStatus.active.name && it.status == UserStatus.active.name }
                    DisableSelection {
                        AssignEmployeeDropdown(
                            users = activeUsers,
                            teams = teams,
                            preSelectedUsers = viewModel.jobSelectedEmployeeList.value,
                            preSelectedTeams = viewModel.jobSelectedTeamList.value,
                            onContactSelected = { employee, teams ->
                                viewModel.jobSelectedEmployeeList.value = employee
                                viewModel.jobSelectedTeamList.value = teams
                            }
                        )
                    }

                    OutlinedCalendarInput(
                        onClick = { viewModel.isStartDateCalendarVisible.value = true },
                        input = viewModel.startDateInputValue,
                        label = stringResource(Res.string.start_date),
                    )

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(8.toScaleDp()) // uniform gap between time fields
                    ) {
                        ReadOnlyTimePickerField(
                            label = stringResource(Res.string.start_at),
                            value = viewModel.startInputValue.value,
                            onClick = { viewModel.isTimePicker1Visible.value = true },
                            modifier = Modifier.weight(1f)
                        )

                        ReadOnlyTimePickerField(
                            label = stringResource(Res.string.end_at),
                            value = viewModel.endInputValue.value,
                            onClick = { viewModel.isTimePicker2Visible.value = true },
                            modifier = Modifier.weight(1f)
                        )
                    }

                    DisableSelection {
                        AddNewJobDropdownInput(
                            viewModel.repeatValue,
                            stringResource(Res.string.repeat),
                            placeholder = stringResource(Res.string.never),
                            dropdownItems = viewModel.repeatMap,
                            onValueChange = {
                                viewModel.isRepeatActive.value =
                                    it != viewModel.repeatMap.entries.find { it.value == Repeat.never.name }?.key
                            },
                        )
                    }

                    if (viewModel.isRepeatActive.value) {
                        val repeatCycle = enumValueOf<Repeat>(
                            viewModel.repeatMap[viewModel.repeatValue.value] ?: Repeat.never.name
                        )
                        when (repeatCycle) {
                            Repeat.never -> {}
                            Repeat.every_day -> {
                                DisableSelection {
                                    AddNewJobDropdownInput(
                                        viewModel.repeatDailyValue,
                                        stringResource(Res.string.repeat_interval),
                                        placeholder = stringResource(Res.string.repeat_interval),
                                        dropdownItems = viewModel.repeatIntervalMap,
                                    )
                                }
                            }

                            Repeat.every_week -> {
//                                val days: MutableState<List<String>> =
//                                    mutableStateOf(DayOfWeek.entries.map { it.name })
//                                MultiSelectDropdownText(
//                                    selectedItems = mutableStateOf(emptyList()),
//                                    onItemSelected = { newSelectedItems ->
//                                        viewModel.repeatWeeklyValue.value = newSelectedItems
//                                    },
//                                    label = stringResource(Res.string.repeat_interval),
//                                    placeholder = stringResource(Res.string.repeat_interval),
//                                    dropdownItems = days,
//                                    preselectedItems = mutableStateOf(emptyList()),
//                                    onAddNewItem = { name ->
//
//                                    }
//                                )
                            }

                            Repeat.every_2_weeks -> {
//                                val days: MutableState<List<String>> =
//                                    mutableStateOf(DayOfWeek.entries.map { it.name })
//                                MultiSelectDropdownText(
//                                    selectedItems = mutableStateOf(emptyList()),
//                                    onItemSelected = { newSelectedItems ->
//                                        viewModel.repeatWeeklyValue.value = newSelectedItems
//                                    },
//                                    label = stringResource(Res.string.repeat_interval),
//                                    placeholder = stringResource(Res.string.repeat_interval),
//                                    dropdownItems = days,
//                                    preselectedItems = mutableStateOf(emptyList()),
//                                    onAddNewItem = { name ->
//
//                                    }
//                                )
                            }

                            Repeat.every_month -> {
//                                OutlinedCalendarInput(
//                                    onClick = {
//                                        viewModel.isCalendarMonthRepeatVisible.value = true
//                                    },
//                                    input = mutableStateOf(DateTimeUtil.formatSelectedDays(viewModel.repeatMonthValue.value)),
//                                    label = stringResource(Res.string.repeat_interval)
//                                )
                            }

                            Repeat.custom -> {

                            }
                        }

                        OutlinedCalendarInput(
                            onClick = { viewModel.isDueDateCalendarVisible.value = true },
                            input = viewModel.dueDateValue,
                            label = stringResource(Res.string.due_date),
                        )
                    }
                }

                Spacer(modifier = Modifier.height(Dp(24f)))

                Text(
                    text = stringResource(Res.string.add_steps),
                    fontSize = Sp(18f),
                    color = TextColor,
                    textAlign = TextAlign.Center,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(Dp(16f)))

                StepInputFields(viewModel.steps)
                Spacer(modifier = Modifier.height(Dp(16f)))

                Column {
                    Text(
                        text = stringResource(Res.string.notes),
                        fontSize = 18.toScaleSp(),
                        color = TextColor,
                        textAlign = TextAlign.Center,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )

                    viewModel.notesListValue.forEach { note ->
                        AppInputFieldWithUpdate(
                            note = note,
                            onNoteChange = { updatedNote ->
                                val updatedNotes =
                                    viewModel.notesListValue.apply {
                                        val index = indexOf(note)
                                        if (index != -1) {
                                            set(index, updatedNote)
                                        }
                                    }
                                viewModel.notesListValue = updatedNotes
                            },
                            label = stringResource(Res.string.add_notes),
                            placeholder = stringResource(Res.string.provide_information),
                            onNoteDeleted = {
                                viewModel.notesListValue.remove(note)
                            }
                        )
                    }
                    Spacer(modifier = Modifier.height(Dp(16f)))

                    Text(
                        text = "+ ${stringResource(Res.string.add_note)}",
                        fontSize = 16.toScaleSp(),
                        color = BlueApp,
                        fontWeight = FontWeight.W700,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .clickableWithPointer {
                                viewModel.addBlankNote()
                            }
                            .padding(8.toScaleDp())
                    )
                }

                Spacer(modifier = Modifier.height(Dp(15f)))
                Text(
                    text = stringResource(Res.string.files),
                    fontSize = Sp(18f),
                    color = TextColor,
                    textAlign = TextAlign.Center,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(Dp(15f)))
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .wrapContentHeight(unbounded = false)
                        .defaultMinSize(minHeight = Dp(200f))
                        .align(Alignment.CenterHorizontally)
                        .drawBehind {
                            val paint = Paint().apply {
                                color = BlueApp
                                style = PaintingStyle.Stroke
                                strokeWidth = Dp(2f).toPx()
                                pathEffect = PathEffect.dashPathEffect(floatArrayOf(10f, 10f), 0f)
                            }
                            drawIntoCanvas { canvas ->
                                canvas.drawRoundRect(
                                    left = 0f,
                                    top = 0f,
                                    right = size.width,
                                    bottom = size.height,
                                    radiusX = Dp(16f).toPx(),
                                    radiusY = Dp(16f).toPx(),
                                    paint = paint
                                )
                            }
                        },
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center,
                        modifier = Modifier.fillMaxSize().clickable {
                            jobId?.let {
                                onUploadDocumentClick(jobId, DocumentType.JOB_FILE)
                            }
                        }
                    ) {
                        if (jobId != DEFAULT_JOB_ID && jobId != "") {
                            if (fileIds.isEmpty()) {
                                Image(
                                    painter = painterResource(Res.drawable.upload_cloud),
                                    contentDescription = "",
                                    modifier = Modifier.size(Dp(40f))
                                )

                                Spacer(modifier = Modifier.height(Dp(8f)))

                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.upload_documents),
                                        color = Color.Black,
                                        fontWeight = FontWeight.Bold,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }

                                Spacer(modifier = Modifier.height(Dp(4f)))

                                Text(
                                    text = stringResource(Res.string.max_size),
                                    color = Color.LightGray,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            } else {
                                Image(
                                    painter = painterResource(Res.drawable.baseline_file_present_24),
                                    contentDescription = "",
                                    modifier = Modifier.padding(top = Dp(24f)).size(Dp(40f))
                                )
                                Column(
                                    modifier = Modifier
                                        .padding(horizontal = Dp(10f))
                                ) {
                                    for (fileId in fileIds) {
                                        Row(
                                            horizontalArrangement = Arrangement.SpaceBetween,
                                            verticalAlignment = Alignment.CenterVertically,
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Text(
                                                text = fileId ?: "",
                                                color = DarkGrey,
                                                fontWeight = FontWeight.Normal,
                                                style = MaterialTheme.typography.body1,
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis,
                                                modifier = Modifier
                                                    .weight(1f)
                                                    .padding(end = Dp(8f))
                                            )

                                            DisableSelection {
                                                Image(
                                                    painter = painterResource(Res.drawable.trash),
                                                    contentDescription = null,
                                                    modifier = Modifier
                                                        .size(Dp(20f))
                                                        .clickable {
                                                            // TODO: not sure
                                                            fileId?.let {
                                                                viewModel.fileToDeleteId.value = it
                                                                viewModel.showAreYouSurePopUpDeleteFile.value =
                                                                    true
                                                            }
                                                        }
                                                )
                                            }
                                        }
                                        Spacer(modifier = Modifier.height(Dp(10f)))
                                    }
                                }
                                Spacer(modifier = Modifier.height(Dp(12f)))
                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.add_more),
                                        color = BlueApp,
                                        fontWeight = FontWeight.Bold,
                                        fontSize = Sp(18f),
                                        modifier = Modifier
                                            .padding(bottom = Dp(24f))
                                            .clickable {
                                                jobId?.let {
                                                    onUploadDocumentClick(
                                                        it,
                                                        DocumentType.JOB_FILE
                                                    )
                                                }
                                            },
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                        } else {
                            if (fileIds.isEmpty()) {
                                Image(
                                    painter = painterResource(Res.drawable.upload_cloud),
                                    contentDescription = "",
                                    modifier = Modifier.size(Dp(40f))
                                )

                                Spacer(modifier = Modifier.height(Dp(8f)))

                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.upload_documents),
                                        color = Color.Black,
                                        fontWeight = FontWeight.Bold,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }

                                Spacer(modifier = Modifier.height(Dp(4f)))

                                Text(
                                    text = stringResource(Res.string.max_size),
                                    color = Color.LightGray,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            } else if (viewModel.isFileUploadError()) {
                                Text(
                                    text = stringResource(Res.string.try_another_document),
                                    color = Color.Gray,
                                    fontWeight = FontWeight.Normal,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            } else {
                                Image(
                                    painter = painterResource(Res.drawable.baseline_file_present_24),
                                    contentDescription = "",
                                    modifier = Modifier.padding(top = Dp(24f)).size(Dp(40f))
                                )
                                Column(
                                    modifier = Modifier
                                        .padding(horizontal = Dp(10f))
                                ) {
                                    for (fileId in fileIds) {
                                        Row(
                                            horizontalArrangement = Arrangement.SpaceBetween,
                                            verticalAlignment = Alignment.CenterVertically,
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Text(
                                                text = fileId,
                                                color = DarkGrey,
                                                fontWeight = FontWeight.Normal,
                                                style = MaterialTheme.typography.body1,
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis,
                                                modifier = Modifier
                                                    .weight(1f)
                                                    .padding(end = Dp(8f))
                                            )

                                            DisableSelection {
                                                Image(
                                                    painter = painterResource(Res.drawable.trash),
                                                    contentDescription = null,
                                                    modifier = Modifier
                                                        .size(Dp(20f))
                                                        .clickable {
                                                            fileId?.let {
                                                                viewModel.fileToDeleteId.value = it
                                                                viewModel.showAreYouSurePopUpDeleteFile.value =
                                                                    true
                                                            }
                                                        }
                                                )
                                            }
                                        }
                                        Spacer(modifier = Modifier.height(Dp(10f)))
                                    }
                                }
                                Spacer(modifier = Modifier.height(Dp(12f)))
                                Text(
                                    text = stringResource(Res.string.add_more),
                                    color = BlueApp,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = Sp(18f),
                                    modifier = Modifier
                                        .padding(bottom = Dp(24f))
                                        .clickable {
                                            onUploadDocumentClick(jobId, DocumentType.JOB_FILE)
                                        },
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                    }
                }

                Text(
                    text = stringResource(Res.string.only_support),
                    fontSize = Sp(12f),
                    color = Color.LightGray,
                    textAlign = TextAlign.Center,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )

                FilledButton(
                    onClick = {
                        viewModel.showLoader.value = true
                        if (jobId == DEFAULT_JOB_ID || jobId == "") {
                            viewModel.addJob(
                                onSuccess = {
                                    viewModel.showLoader.value = false
                                    viewModel.showPopUpSuccess.value = true
                                },
                                onError = {
                                    viewModel.showLoader.value = false
                                    viewModel.showPopUpError.value = true
                                })
                        } else {
                            jobId?.let {
                                viewModel.updateJob(
                                    it,
                                    onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    },
                                    onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            }
                        }
                    },
                    modifier = Modifier.padding(
                        start = Dp(16f),
                        end = Dp(16f),
                        top = Dp(30f),
                        bottom = Dp(20f)
                    ),
                    text = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(Res.string.add) else stringResource(
                        Res.string.update
                    ),
                    isEnabled = true
                )
                if (viewModel.isTimePicker1Visible.value) {
                    CustomTimePicker(
                        time = viewModel.startInputValue.value,
                        onDismiss = {
                            viewModel.isTimePicker1Visible.value = false
                        },
                        onTimeSelected = {
                            if (it == "") {
                                viewModel.startInputValue.value = startAtString
                            } else {
                                viewModel.startInputValue.value = it
                            }
                            viewModel.isTimePicker1Visible.value = false
                        },
                        defaultTime = "08:00",
                        showClear = viewModel.startInputValue.value != startAtString
                    )
                }
                val errorString = stringResource(Res.string.start_end_time)
                val startRequiredString = stringResource(Res.string.job_start_time_error)
                if (viewModel.isTimePicker2Visible.value) {
                    CustomTimePicker(
                        time = viewModel.endInputValue.value,
                        onDismiss = {
                            viewModel.isTimePicker2Visible.value = false
                        },
                        onTimeSelected = { selectedTime ->
                            if (selectedTime == "") {
                                viewModel.endInputValue.value = endAtString
                                viewModel.isTimePicker2Visible.value = false
                            } else if (viewModel.startInputValue.value == startAtString) {
                                viewModel.errorText.value = startRequiredString
                                viewModel.showPopUpError.value = true
                                viewModel.endInputValue.value = endAtString
                            } else if (selectedTime == viewModel.startInputValue.value || selectedTime < viewModel.startInputValue.value) {
                                viewModel.errorText.value = errorString
                                viewModel.showPopUpError.value = true
                                viewModel.endInputValue.value = endAtString
                            } else {
                                viewModel.endInputValue.value = selectedTime
                                viewModel.isTimePicker2Visible.value = false
                                // viewModel.calculateDuration()
                            }
                        },
                        defaultTime = "16:00",
                        showClear = viewModel.endInputValue.value != endAtString
                    )
                }
                val error = stringResource(Res.string.date_error)
                if (viewModel.isStartDateCalendarVisible.value) {
                    CustomCalendarView(
                        isMultiDay = false,
                        selectionMode = SelectionMode.Single,
                        onDismiss = { viewModel.isStartDateCalendarVisible.value = false },
                        onDateSelect = {
                            if (it.isNotEmpty()) {
                                viewModel.startDateInputValue.value = it[0].toString()
                            }
                        },
                        showErrorMessage = {
                            viewModel.showPopUpError.value = true
                            viewModel.errorText.value = error
                        })
                }
                if (viewModel.isDueDateCalendarVisible.value) {
                    CustomCalendarView(
                        isMultiDay = false,
                        selectionMode = SelectionMode.Single,
                        startDate = try {
                            LocalDate.parse(viewModel.startDateInputValue.value)
                        } catch (e: Exception) {
                            Clock.System.todayIn(TimeZone.currentSystemDefault())
                        },
                        minDate = try {
                            LocalDate.parse(viewModel.startDateInputValue.value)
                        } catch (e: Exception) {
                            Clock.System.todayIn(TimeZone.currentSystemDefault())
                        },
                        onDismiss = { viewModel.isDueDateCalendarVisible.value = false },
                        onDateSelect = {
                            if (it.isNotEmpty()) {
                                viewModel.dueDateValue.value = it[0].toString()
                            }
                        },
                        showErrorMessage = {
                            viewModel.showPopUpError.value = true
                            viewModel.errorText.value = error
                        })
                }
                if (viewModel.isCalendarMonthRepeatVisible.value) {
                    CustomCalendarView(
                        isMultiDay = true,
                        selectionMode = SelectionMode.Multiply(30),
                        onDismiss = { viewModel.isCalendarMonthRepeatVisible.value = false },
                        onDateSelect = {
                            viewModel.repeatMonthValue.value = it
                        },
                        showErrorMessage = {
                            viewModel.showPopUpError.value = true
                            viewModel.errorText.value = error
                        })
                }
                if (viewModel.showPopUpSuccess.value) {
                    PopUpDialog(
                        onDismiss = {
                            viewModel.showPopUpSuccess.value = false
                            navHostController.popBackStack()
                        },
                        title = stringResource(Res.string.success).uppercase(),
                        message = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(Res.string.job_added) else stringResource(
                            Res.string.job_updated
                        ),
                        onPositiveBtnClicked = {
                            viewModel.showPopUpSuccess.value = false
                            navHostController.popBackStack()
                        },
                        positiveBtnText = stringResource(Res.string.ok)
                    )
                }
                if (viewModel.showPopUpError.value) {
                    ErrorDialog(
                        onDismiss = { viewModel.showPopUpError.value = false },
                        title = stringResource(Res.string.error).uppercase(),
                        message = viewModel.errorText.value
                    )
                }
                if (viewModel.showLoader.value) {
                    FullScreenProgressBar()
                }
                if (viewModel.showAreYouSurePopUpDeleteFile.value) {
                    PopUpDialog(
                        onDismiss = { viewModel.showAreYouSurePopUpDeleteFile.value = false },
                        title = stringResource(Res.string.confirmation),
                        message = stringResource(Res.string.are_you_sure),
                        onPositiveBtnClicked = {
                            viewModel.fileToDeleteId.value?.let {
                                viewModel.deleteUploadedFile(it)
                            }
                            viewModel.showAreYouSurePopUpDeleteFile.value = false
                        },
                        onNegativeBtnClicked = {
                            viewModel.showAreYouSurePopUpDeleteFile.value = false
                        },
                        positiveBtnText = stringResource(Res.string.delete),
                        negativeBtnText = stringResource(Res.string.cancel)
                    )
                }
            }
        }
    } else {
        SelectionContainer {
            AddNewJobScreenWeb(
                jobId = jobId,
                users = users,
                teams = teams,
                fileIds = fileIds,
                viewModel = viewModel,
                navHostController = navHostController,
                onUploadDocumentClick = onUploadDocumentClick
            )
        }
    }
}
